export default "__VITE_ASSET__C08xjtKn__"